<template>
  <v-card class="pa-4 rounded-lg" color="background">
    <v-dialog v-model="dialog" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              this.currentEquipment.alienated
                ? $t('Tem certeza em desalienar este equipamento?')
                : $t('Tem certeza em alienar este equipamento?')
            }}
          </div>

          <v-btn class="ma-1" color="grey" text @click="dialog = false">
            {{ $t('Não') }}
          </v-btn>

          <v-btn class="ma-1" color="#B14949" text @click="alienateEquipment">
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="confirmDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t(
                'Ao confirmar todas as Ordens de Serviço não fechadas serão arquivadas.'
              )
            }}
          </div>

          <v-btn class="ma-1" color="grey" text @click="confirmDialog = false">
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn class="ma-1" color="#B14949" text @click="submit">
            {{ $t('Confirmar') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="signatureConfirmDialog" max-width="600">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          style="width: 100%"
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t('Gostaria de assinar este modelo de alienação de equipamento?')
            }}
          </div>

          <div class="d-flex justify-center">
            <v-radio-group v-model="option" dark row>
              <v-radio :value="0">
                <template v-slot:label>
                  <span class="grey--text text-body-2">
                    {{ $t('Usar assinatura armazenada') }}
                  </span>
                </template>
              </v-radio>
              <v-radio :value="1">
                <template v-slot:label>
                  <span class="grey--text text-body-2">
                    {{ $t('Assinar agora') }}
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <v-expand-transition>
            <div v-if="option == 1">
              <SignatureScreen
                v-model="currentEquipment.validatorName"
                @save="sign"
              />
            </div>
          </v-expand-transition>

          <v-btn
            v-if="option == 0"
            :disabled="loading"
            depressed
            class="ma-1"
            color="grey"
            @click="signatureConfirmDialog = false"
          >
            {{ $t('Não') }}
          </v-btn>

          <v-btn
            v-if="option == 0"
            :loading="loading"
            class="ma-1"
            depressed
            color="#B14949"
            @click="sign"
          >
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-window v-model="step" touchless>
      <v-window-item :value="0">
        <v-form class="form" ref="firstForm" v-model="firstValid">
          <div v-if="!currentEquipment.alienated">
            <span class="text-caption grey--text">
              {{ $t('ENGENHARIA CLÍNICA E HOSPITALAR') }}
            </span>
            <br />
            <strong class="text-subtitle-2" style="font-weight: 900">
              {{ $t('MODELO DE AVALIAÇÃO DE EQUIPAMENTOS') }}
            </strong>

            <div class="mt-4">
              <v-card class="card-pad text-subtitle-2 text-center">
                {{ $t('Dados gerais do equipamento') }}
              </v-card>
              <v-row class="ma-0">
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Equipamento') }}: </strong>
                  <span class="text-body-2">
                    {{ currentEquipment.name }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Nº identificação') }}: </strong>
                  <span class="text-body-2">
                    {{ currentEquipment.identification }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Fabricante') }}: </strong>
                  <span class="text-body-2">
                    {{ currentEquipment.manufacturer }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Modelo') }}: </strong>
                  <span class="text-body-2">
                    {{ currentEquipment.model }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Setor') }}: </strong>
                  <span class="text-body-2">
                    {{ currentEquipment.sector }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Nº série') }}: </strong>
                  <span class="text-body-2">
                    {{ currentEquipment.serialNumber }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Valor de aquisição') }}: </strong>
                  <span class="text-body-2">
                    {{
                      currentEquipment.aquisitionValue
                        ? currentEquipment.aquisitionValue.toInstLocale()
                        : '0,00'
                    }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> Data de aquisição: </strong>
                  <span class="text-body-2">
                    {{
                      currentEquipment.aquisitionDate
                        ? formatDate(currentEquipment.aquisitionDate)
                        : $t('Sem registros')
                    }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Registro ANVISA') }}: </strong>
                  <span class="text-body-2">
                    {{
                      currentEquipment.anvisaRegister
                        ? currentEquipment.anvisaRegister
                        : $t('Sem registros')
                    }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Término da garantia') }}: </strong>
                  <span class="text-body-2">
                    {{
                      currentEquipment.warrantyEnd
                        ? formatDate(currentEquipment.warrantyEnd)
                        : $t('Sem registros')
                    }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Patrimônio') }}: </strong>
                  <span class="text-body-2">
                    {{ currentEquipment.patrimony }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Criticidade') }}: </strong>
                  <span class="text-body-2">
                    {{ currentEquipment.criticality }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong> {{ $t('Possui contrato vinculado?') }} </strong>
                </v-col>
                <v-col class="d-flex align-center" cols="12" sm="6">
                  <v-radio-group
                    readonly
                    v-model="currentEquipment.haveContract"
                    row
                    hide-details
                    class="mt-0"
                  >
                    <v-radio :label="$t('Não')" :value="false"></v-radio>
                    <v-radio :label="$t('Sim')" :value="true"></v-radio>
                  </v-radio-group>

                  <strong class="mt-1" v-if="currentEquipment.contractInfo">
                    {{ $t('Cobertura') }}:
                  </strong>
                  <span class="text-body-2 mt-1 ml-2">
                    {{ currentEquipment.contractInfo }}
                  </span>
                </v-col>
              </v-row>
            </div>

            <div class="mt-4">
              <v-card
                class="card-pad text-subtitle-2 text-center"
                style="position: relative"
              >
                {{ $t('Relação de acessórios') }}
                <v-btn x-small absolute right @click="addRelation" icon text>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-card>
              <v-row
                class="ma-0"
                v-for="(relation, i) in acessoriesRelation"
                :key="i"
                justify="center"
              >
                <v-col cols="12" sm="3" class="d-flex align-center">
                  <strong class="mr-2"> {{ $t('Descrição') }}: </strong>
                  <v-text-field
                    v-model="relation.description"
                    :rules="[(v) => !!v || 'Descrição obrigatória']"
                    dense
                    hide-details="auto"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex align-center">
                  <strong class="mr-2"> {{ $t('Quantidade') }}: </strong>
                  <v-text-field
                    v-model="relation.qtd"
                    type="number"
                    :rules="[(v) => !!v || 'Quantidade obrigatória']"
                    dense
                    hide-details="auto"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex align-center">
                  <strong class="mr-2"> {{ $t('Código ou NS') }}: </strong>
                  <v-text-field
                    v-model="relation.code"
                    :rules="[(v) => !!v || 'Código obrigatório']"
                    dense
                    hide-details="auto"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    class="secondary-button"
                    color="error"
                    depressed
                    small
                    @click="removeRelation(i)"
                  >
                    {{ $t('Remover') }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <div class="mt-4">
              <v-card class="card-pad text-subtitle-2 text-center">
                {{ $t('Classificação tecnológica') }}
              </v-card>
              <div class="d-flex justify-center">
                <v-radio-group
                  row
                  hide-details
                  readonly
                  v-model="currentEquipment.techClassification"
                >
                  <v-radio :label="$t('Apoio')" value="apoio"></v-radio>
                  <v-radio
                    :label="$t('Diagnóstico')"
                    value="diagnostico"
                  ></v-radio>
                  <v-radio
                    :label="$t('Suporte à vida')"
                    value="suporte"
                  ></v-radio>
                  <v-radio :label="$t('Terapia')" value="terapia"></v-radio>
                </v-radio-group>
              </div>
            </div>

            <div class="mt-4">
              <v-card class="card-pad text-subtitle-2 text-center">
                {{ $t('Análise de desempenho (últimos 12 meses)') }}
              </v-card>
              <v-row class="ma-0">
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <strong class="mr-2">
                    {{ $t('Quantidade de falhas intrínsicas') }}:
                  </strong>
                  <span class="text-body-2">{{
                    currentEquipment.intrinsicFailuresQuantity
                  }}</span>
                </v-col>
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <strong class="mr-2"> MTBF: </strong>
                  <span class="text-body-2">{{
                    currentEquipment.mtbf ? currentEquipment.mtbf : 0
                  }}</span>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <strong class="mr-2">
                    {{ $t('Custo acumulado com manutenção (em reais)') }}:
                  </strong>
                  <span class="text-body-2">
                    {{
                      currentEquipment.cumulativeMaintenenceCost
                        ? currentEquipment.cumulativeMaintenenceCost.toInstLocale()
                        : '0,00'
                    }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6">
                  <strong class="mr-2">
                    {{
                      $t('Laudos estão em dia (preventiva, calibração, e SE)?')
                    }}
                  </strong>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-radio-group
                    row
                    hide-details
                    class="mt-0"
                    v-model="currentEquipment.reportUpToDate"
                    :rules="[(v) => v != null || 'Campo obrigatório']"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio :label="$t('Sim')" :value="true"></v-radio>
                    <v-radio :label="$t('Não')" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong class="mr-2">
                    {{ $t('Equipamento envolvido em algum acidente?') }}
                  </strong>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-radio-group
                    row
                    hide-details
                    class="mt-0"
                    v-model="currentEquipment.involvedInAccident"
                    :rules="[(v) => v != null || 'Campo obrigatório']"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio :label="$t('Não')" :value="false"></v-radio>
                    <v-radio :label="$t('Sim')" :value="true"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12" sm="6">
                  <strong class="mr-2">
                    {{ $t('Funcionamento geral do equipamento') }}:
                  </strong>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-radio-group
                    row
                    hide-details
                    class="mt-0"
                    v-model="currentEquipment.generalOperation"
                    :rules="[(v) => v != null || 'Campo obrigatório']"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio :label="$t('Conforme')" :value="true"></v-radio>
                    <v-radio
                      :label="$t('Não conforme')"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12" sm="6">
                  <strong class="mr-2">
                    {{ $t('Condições físicas e estruturais') }}:
                  </strong>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-radio-group
                    row
                    hide-details
                    class="mt-0"
                    v-model="currentEquipment.physicalStructuralConditions"
                    :rules="[(v) => v != null || 'Campo obrigatório']"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio :label="$t('Conforme')" :value="true"></v-radio>
                    <v-radio
                      :label="$t('Não conforme')"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12" sm="6">
                  <strong class="mr-2">
                    {{ $t('Condições dos acessórios') }}:
                  </strong>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-radio-group
                    row
                    hide-details
                    class="mt-0"
                    v-model="currentEquipment.accessoriesConditions"
                    :rules="[(v) => v != null || 'Campo obrigatório']"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio :label="$t('Conforme')" value="conforme"></v-radio>
                    <v-radio
                      :label="$t('Não conforme')"
                      value="naoconforme"
                    ></v-radio>
                    <v-radio
                      label="Não aplicável"
                      value="naoaplicavel"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12" class="text-center">
                  <strong class="mr-2">
                    {{
                      $t(
                        'Produtividade( efetividade nas práticas clínicas, receita gerada, número de exames)'
                      )
                    }}:
                  </strong>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                  <v-radio-group
                    row
                    hide-details
                    class="mt-0"
                    v-model="currentEquipment.productivity"
                    :rules="[(v) => v != null || 'Campo obrigatório']"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio :label="$t('Bom')" value="bom"></v-radio>
                    <v-radio :label="$t('Regular')" value="regular"></v-radio>
                    <v-radio :label="$t('Ruim')" value="ruim"></v-radio>
                    <v-radio
                      :label="$t('Não aplicável')"
                      value="naoaplicavel"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </div>

            <div class="mt-4">
              <v-card class="card-pad text-subtitle-2 text-center">
                {{ $t('Fatores de vida') }}
              </v-card>

              <v-row class="ma-0">
                <v-col cols="12" class="d-flex justify-center">
                  <v-radio-group
                    row
                    hide-details
                    v-model="currentEquipment.lifeFactor"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio
                      :label="$t('Em fabricação')"
                      :value="null"
                    ></v-radio>
                    <v-radio label="End of Life" :value="0"></v-radio>
                    <v-radio label="End of Service" :value="1"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <strong class="mr-2">
                    {{ $t('Equipamento adequado às normas vigentes') }}:
                  </strong>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-radio-group
                    row
                    hide-details
                    class="mt-0"
                    v-model="currentEquipment.adequateRegulations"
                    :rules="[(v) => v != null || 'Campo obrigatório']"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio :label="$t('Sim')" :value="true"></v-radio>
                    <v-radio :label="$t('Não')" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="4" class="d-flex align-center">
                  <strong class="mr-2">
                    {{ $t('Condições do registro') }}:
                  </strong>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-radio-group
                    row
                    hide-details
                    class="mt-0"
                    v-model="currentEquipment.registerConditions"
                    :rules="[(v) => v != null || 'Campo obrigatório']"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio :label="$t('Ativo')" value="ativo"></v-radio>
                    <v-radio
                      :label="$t('Existente, porém inativo')"
                      value="existe"
                    ></v-radio>
                    <v-radio :label="$t('Não possui')" value="null"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </div>

            <div class="mt-4">
              <v-card class="card-pad text-subtitle-2 text-center">
                {{ $t('Laudo técnico') }}
              </v-card>

              <v-row class="ma-0">
                <v-col cols="12" sm="8">
                  <v-row class="ma-0" no-gutters>
                    <v-col cols="12" class="d-flex align-center">
                      <strong class="mr-2">
                        {{
                          $t(
                            'Parecer técnico (considerando a Análise de Desempenho e Fatores de Vida)'
                          )
                        }}:
                      </strong>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        dense
                        :rules="[(v) => v != null || 'Campo obrigatório']"
                        hide-details="auto"
                        v-model="currentEquipment.alienationMotive"
                        :disabled="currentEquipment.alienated"
                      >
                        <template #message="{ message }">
                          {{ $t(message) }}
                        </template>
                      </v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-radio-group
                        hide-details
                        v-model="currentEquipment.condition"
                        :rules="[(v) => v != null || 'Campo obrigatório']"
                      >
                        <template #message="{ message }">
                          {{ $t(message) }}
                        </template>
                        <v-radio
                          :label="$t('Funcionando e atualizado')"
                          value="atualizado"
                        ></v-radio>
                        <v-radio
                          :label="$t('Obsolescência funcional')"
                          value="funcional"
                        ></v-radio>
                        <v-radio
                          :label="$t('Obsolescência física')"
                          value="fisica"
                        ></v-radio>
                        <v-radio
                          :label="$t('Possível reforma/reparo')"
                          value="reparo"
                        ></v-radio>
                        <v-radio
                          :label="$t('Funcionando, porém defasado')"
                          value="defasado"
                        ></v-radio>
                        <v-radio
                          :label="$t('Extravio')"
                          value="extravio"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-hover v-if="selectedImage" v-slot="{ hover }">
                    <v-img
                      style="border: 1px dashed grey; border-radius: 8px"
                      height="100%"
                      :src="selectedImage"
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="d-flex align-center justify-center transition-fast-in-fast-out error darken-2 v-card--reveal text-h2 white--text"
                          style="height: 100%"
                        >
                          <v-btn text icon large @click="selectedImage = ''">
                            <v-icon color="white">
                              mdi-trash-can-outline
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </v-hover>

                  <div v-else class="picImage" @click="picImage">
                    <span class="text-caption">{{ $t('Imagem') }}</span>
                  </div>

                  <v-file-input
                    id="fileinput"
                    @change="setImage"
                    class="d-none"
                    accept="image/png, image/jpeg, image/bmp"
                  ></v-file-input>
                </v-col>
              </v-row>
            </div>

            <div class="mt-4">
              <v-card class="card-pad text-subtitle-2 text-center">
                {{ $t('Destinação Final') }}
              </v-card>

              <v-row class="ma-0">
                <v-col cols="12" class="d-flex justify-center">
                  <v-radio-group
                    row
                    hide-details
                    v-model="currentEquipment.finalDestination"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                    <v-radio :label="$t('Substituição')" :value="0"></v-radio>
                    <v-radio label="Logística Reversa" :value="1"></v-radio>
                    <v-radio label="Doação" :value="2"></v-radio>
                    <v-radio label="Descarte" :value="3"></v-radio>
                    <v-radio label="Outros" :value="4"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    dense
                    :rules="[(v) => v != null || 'Campo obrigatório']"
                    hide-details="auto"
                    v-model="currentEquipment.finalDestinationObs"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>
          </div>

          <div class="mt-4">
            <v-row class="ma-0" justify="end">
              <v-col
                cols="12"
                class="d-flex align-center"
                v-if="currentEquipment.alienated"
              >
                <strong class="mr-2">
                  {{
                    $t(
                      'Parecer técnico (considerando a Análise de Desempenho e Fatores de Vida)'
                    )
                  }}:
                </strong>
              </v-col>
              <v-col v-if="currentEquipment.alienated" cols="12">
                <v-textarea
                  dense
                  :rules="[(v) => v != null || 'Campo obrigatório']"
                  hide-details="auto"
                  v-model="currentEquipment.alienationMotive"
                  :disabled="currentEquipment.alienated"
                >
                  <template #message="{ message }">
                    {{ $t(message) }}
                  </template>
                </v-textarea>
              </v-col>

              <v-col cols="12" sm="5" class="d-flex align-center">
                <strong class="mr-2"> {{ $t('Data alienação') }}: </strong>
                <v-menu
                  ref="menuAlienationDate"
                  v-model="menuAlienationDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      hide-details="auto"
                      v-model="alienationDate"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="
                        currentEquipment.alienationDate =
                          parseDate(alienationDate)
                      "
                      v-bind="attrs"
                      v-on="on"
                      :rules="[
                        (v) =>
                          currentEquipment.alienated ||
                          !!v ||
                          'Data de alienação requerida',
                      ]"
                      :disabled="currentEquipment.alienated"
                    >
                      <template #message="{ message }">
                        {{ $t(message) }}
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="currentEquipment.alienationDate"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    no-title
                    @change="save"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>

          <div class="mt-4" v-if="!currentEquipment.alienated">
            <v-card class="card-pad text-subtitle-2 text-center">
              {{ $t('Validação') }}
            </v-card>

            <v-row class="ma-0">
              <v-col cols="12" sm="6" class="d-flex align-center">
                <strong class="mr-2"> {{ $t('Nome') }}: </strong>
                <span class="text-body-2">{{ user.name }}</span>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex align-center">
                <strong class="mr-2"> {{ $t('Cargo') }}: </strong>
                <span class="text-body-2">{{ levels[user.userOffice] }}</span>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <strong class="mr-2"> {{ $t('Assinatura') }}: </strong>

                <img
                  v-if="signImage"
                  :src="signImagePath"
                  alt=""
                  style="max-width: 600px"
                />

                <v-btn
                  v-else
                  depressed
                  class="secondary-button ma-1"
                  @click="signatureConfirmDialog = true"
                >
                  {{ $t('Assinar') }}
                </v-btn>
                <v-btn
                  color="error"
                  depressed
                  fab
                  class="secondary-button ma-1"
                  @click="signImage = ''"
                  v-if="!!signImage"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-window-item>

      <v-window-item :value="1">
        <div class="fill-height text-center pa-8">
          <v-icon large color="success"> mdi-checkbox-marked-circle </v-icon>

          <span style="display: block; margin-top: 10px; font-size: 1.2rem">
            {{
              this.currentEquipment.alienated
                ? $t('Equipamento desalienado com sucesso!')
                : $t('Equipamento alienado com sucesso!')
            }}
          </span>
        </div>
      </v-window-item>
    </v-window>

    <v-divider class="mt-5"></v-divider>

    <div class="d-flex justify-end">
      <v-btn color="#426483" depressed @click="next" :loading="loading">
        {{ $t(buttonText) }}
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped>
.picImage {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed grey;
  border-radius: 8px;
  transition: 0.3s;
}

.picImage:hover {
  background: #f9f9f9;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import SignatureScreen from '../../../../components/SignatureScreen.vue'
import utils from '../../../../Utils/FormatDate'

export default {
  props: {
    equipment: Object,
  },

  components: {
    SignatureScreen,
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))

    if (this.equipment) {
      this.getInfo()
    }
  },

  data: () => ({
    acessoriesRelation: [
      {
        description: '',
        qtd: '',
        code: '',
      },
      {
        description: '',
        qtd: '',
        code: '',
      },
      {
        description: '',
        qtd: '',
        code: '',
      },
    ],
    selectedImage: '',
    signImage: '',
    option: 0,
    signatureConfirmDialog: false,
    signImagePath: '',
    user: {},
    step: 0,
    errorMessage: '',
    menuAlienationDate: false,
    loading: false,
    firstValid: false,
    error: false,
    dialog: false,
    confirmDialog: false,
    alienationDate: null,
    alienated: false,
    levels: [
      'Auxiliar',
      'Coordenador',
      'Enfermeiro',
      'Engenheiro',
      'Estagiário',
      'Recepcionista',
      'Supervisor',
      'Técnico',
      'Farmacêutico',
      'Fisioterapeuta',
      'Administrativo',
      'Gerente',
      'Nutricionista',
    ],
    currentEquipment: {
      id: 0,
      alienated: false,
      alienationMotive: '',
      alienationDate: null,
    },
    alienationMotiveRules: [
      (v) => currentEquipment.alienated || !!v || 'Motivo requerido',
    ],
    alienationDateRules: [
      (v) => currentEquipment.alienated || !!v || 'Data da alienação requeirda',
    ],
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.currentEquipment.alienated ? 'Desalienar' : 'Alienar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    formatDate(date) {
      return utils.dateTime(date)
    },

    addRelation() {
      this.acessoriesRelation.push({
        description: '',
        qtd: '',
        code: '',
      })
    },

    removeRelation(index) {
      this.acessoriesRelation.splice(index, 1)
    },

    picImage() {
      document.getElementById('fileinput').click()
    },

    setImage(image) {
      if (image.size > 2000000) {
        this.$toast.warning(
          'Só é permitido envio de imagens com no máximo 2mb!'
        )
      } else {
        const reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = () => {
          this.selectedImage = reader.result
        }
      }
    },

    sign(data) {
      if (this.option == 0) {
        if (this.user.signatureImage) {
          if (
            this.user.signatureImage.includes(
              'https://equipacarefix.blob.core.windows.net/'
            )
          ) {
            this.signImage = this.user.signatureImage
            this.signImagePath = this.user.signatureImage
          } else {
            this.signImage = `wwwroot/Uploads/Users/${this.user.id}/signatureImage`
            this.signImagePath = `${process.env.VUE_APP_BASE_URL}Uploads/Users/${this.user.id}/signatureImage/${this.user.signatureImage}`
          }

          this.signatureConfirmDialog = false
        } else {
          this.$toast.error(
            'Assinatura não encontrada, verifique se existe uma assinatura cadastrada em seu usuário'
          )
        }
      } else {
        this.signImage = data
        this.signImagePath = data
        this.signatureConfirmDialog = false
      }
    },

    async getInfo() {
      await this.apiService
        .get(`equipment/info/${this.equipment.id}`)
        .then((response) => {
          this.currentEquipment = response.content
          if (this.equipment.alienationDate != null) {
            this.alienationDate = this.formatInitialDate(
              this.equipment.alienationDate
            )
          }
        })
    },

    close() {
      this.$emit('close')
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.dialog = true
        }
      } else {
        this.close()
      }
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    save(date) {
      this.alienationDate = this.formatInputDate(
        this.currentEquipment.alienationDate
      )
      this.$refs.menuAlienationDate.save(date)
    },

    alienateEquipment() {
      if (this.currentEquipment.alienated) {
        this.submit()
      } else {
        this.dialog = false
        this.confirmDialog = true
      }
    },

    async submit() {
      this.loading = true

      this.currentEquipment.signImage = this.signImage
      this.currentEquipment.signImage = this.signImage
      this.currentEquipment.techImage = this.selectedImage
      this.currentEquipment.alienated = !this.currentEquipment.alienated
      this.currentEquipment.userName = this.user.name
      this.currentEquipment.userType = this.levels[this.user.userOffice]
      this.currentEquipment.acessoriesRelation = this.acessoriesRelation

      this.currentEquipment.alienationDate = this.currentEquipment.alienated
        ? this.currentEquipment.alienationDate
        : null

      this.currentEquipment.alienationMotive = this.currentEquipment.alienated
        ? this.currentEquipment.alienationMotive
        : ''

      await this.apiService
        .post('equipment/alienate', this.currentEquipment)
        .then((response) => {
          if (this.currentEquipment.alienated) {
            var pedfResult = 'data:application/pdf;base64,' + response.content
            const link = document.createElement('a')
            link.href = pedfResult
            link.setAttribute('download', `EquipamentoAlienado`)
            document.body.appendChild(link)
            link.click()
          }

          this.dialog = false
          this.step++
          this.loading = false
          this.$router.push('/equipment')
        })
    },
  },
}
</script>
